module.exports = __webpack_public_path__ + "media/images/workplace/intro-page/us_bank_general_icon-3cc2033527cc5369634be4fd5f6e62f5.png";